import { Controller, useFormContext } from "react-hook-form";

import {
  Checkbox,
  FormControlLabel,
  Grid,
  Paper,
  Typography,
} from "@mui/material";

import { CustomDatePicker, CustomInputField } from "@/features/ui";

export const EditableFieldsSection = () => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="subtitle1">Detail Retur Penjualan</Typography>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Controller
            name="transactionDate"
            control={control}
            render={({ field, fieldState }) => (
              <CustomDatePicker
                value={field.value}
                onChange={field.onChange}
                required
                label="Tanggal Transaksi"
                error={fieldState.invalid}
                helperText={fieldState.error?.message}
                InputProps={{
                  disableFuture: true,
                }}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <CustomInputField
            name="note"
            label="Catatan"
            placeholder="Kosongkan untuk memakai catatan retur pembelian"
            register={register}
            error={!!errors.note}
            helperText={errors.note?.message}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Controller
            name="resend"
            control={control}
            render={({ field }) => (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!field.value}
                    onChange={(event) => field.onChange(event.target.checked)}
                  />
                }
                label="Kirim ulang barang yang diretur"
              />
            )}
          />
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Membuat pesanan pengganti (PO &rarr; SO) untuk outlet peretur,
            ditagih terpisah dan tertaut ke pesanan aslinya.
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};
